import { EntityType } from "@mapmycustomers/shared/enum";

export const RECORDS_PAST_DUE_ENTITY_TYPES = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
] as const;
